import { WorldLevels } from './FundPersonDtoOut';

export const COORDINATOR_ADD_REQUESTS_URL = 'management/coordinator-add-requests';

export const fundAddRequestsUrl = (fundId: number) => `funds/${fundId}/people/add-requests`;

export type CoordinatorAddRequestStatus = 'Pending' | 'Approved' | 'Rejected' | 'Cancelled';

/**
 * SPR-10486: a lead coordinator's request to add a coordinator, waiting for the office - on the
 * fund's «רכזים והרשאות» and on the office's «בקשות הוספת רכז».
 */
export interface CoordinatorAddRequestDtoOut {
  id: number;
  fundId: number;
  fundName: string | null;
  israeliId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  worlds: WorldLevels;
  status: CoordinatorAddRequestStatus;
  requestedByEmail: string | null;
  requestedByName: string | null;
  requestedAt: string;
  reviewedAt: string | null;
  rejectionReason: string | null;
  /** How many ID copies the lead coordinator attached. */
  idDocumentsCount: number;
  /** The ID copies with download links - sent to the office only. */
  idDocuments: { name: string; description: string; uri: string }[] | null;
}

/**
 * The server sends the request's times in UTC without saying so ("2026-11-03T07:53:43"), and a
 * browser reads such a string as local time - two hours early in Israel (HAT-10552). A time that
 * names its zone is left as it is.
 */
export const asUtc = (value: string) => (/(z|[+-]\d\d:?\d\d)$/i.test(value) ? value : `${value}Z`);
